import { Modal } from 'antd';
import classNames from 'classnames';
import AffinitySearchResultItem from 'Components/person/components/AffinitySearchResultItem';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  maxMobile,
  primaryColor, primaryFont, secondaryFont, wLight, wMBold,
} from 'Utils/utilsStyle';
import { useDispatch, useSelector } from 'react-redux';
import { Executive } from 'Types/PersonTypes';
import { SearchResultsRequest } from 'Types/GlobalSearchResultsTypes';
import { actions as companyActions } from 'Slice/CompaniesSlice';
import { actions as actionsSearch } from 'Slice/AffinitySearchResultsSlice';
import { actions as UiAction } from 'Slice/UISlice';
import { NODATAFOUND } from 'Utils/Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  selectSearchResultsPage,
  selectBuyerPeopleData,
  selectBuyerExtendedLoading,
  selectBuyerLoading,
} from 'Selector/AffinitySearchSelector';
import {
  selectBuyerStaff, selectBuyerStaffCount,
  selectBuyerStaffLoading, selectBuyerStaffPage, selectBuyerStaffPerson,
  selectCompanyId,
} from 'Selector/CompaniesSelector';
import { selectPersonId, selectUserCompanyId } from 'Selector/GlobalSearchContentSelector';
import { formatNumberWithCommas, getLangCookie, validateSearchQuery } from 'Utils/UtilityFunctions';
import BuyerAlertSearch from 'Components/alerts/components/BuyerAlertsSearch';
import AffinitySearchResultItemSkeleton from '../skeleton/AffinitySearchResultItemSkeleton';
import NoDataFound from '../components/NoDataFound';

const Wrapper = styled.div`
.share-button-group {
  &.groupPageButton {
    height: 40px;
    padding: 8px 12px 8px 12px;
    border-radius: 8px;
    @media all and (max-width: ${maxMobile}) {
      padding: 10px 12px 2px 12px;
    }
    .icon-mode-text, .seperator {
      @media all and (max-width: ${maxMobile}) {
        display: none;
      }
    }
  }
  background-color: ${primaryColor};
  height: 30px;
  border-radius: 17px;
  padding: 7px 16px;
  font-family: ${secondaryFont};
  color: #fff;
  font-weight: ${wMBold};
  font-size: 14px;
  line-height: 17.09px;
  .icon-mode {
    display: inline-flex;
    align-content: center;
    column-gap: 8px;
    .icon-mode-text {
      font-weight: ${wLight};
      font-family: ${primaryFont};
      font-size: 14px;
    }
    .seperator {
      height: 18px;
      border-left: 1.5px solid #fff;
      margin: 0px 10px;
    }
    .share-icon {
      svg {
        height: 18px;
        width: 13px;
        min-width: 13px;
      }
    }
  }
}
`;

type Props = {
  sapBuyerAnalysis?: boolean,
  showPopupForSAP?: boolean,
  setShowPopupForSAP?: () => void,
  goToNextSlide?: () => void
  buyerSearchQuery: string,
  setBuyerSearchQuery: (e: string) => void
  prevSearchTerm: string
  setPrevSearchTerm: (e: string) => void
  updateDesignationsInSap?: () => void
} & typeof defaultProps;

const defaultProps = {
  sapBuyerAnalysis: false,
  showPopupForSAP: false,
  setShowPopupForSAP: () => { },
  goToNextSlide: () => { },
  updateDesignationsInSap: () => { },
};

const BuyerGroupModal = function BuyerGroupModal(props: Props) {
  const {
    sapBuyerAnalysis, setShowPopupForSAP, showPopupForSAP, goToNextSlide,
    buyerSearchQuery, setPrevSearchTerm, setBuyerSearchQuery, prevSearchTerm,
    updateDesignationsInSap,
  } = props;
  const dispatch = useDispatch();

  const userCompanyIdParsed = useSelector(selectUserCompanyId);
  const companyIdParsed = useSelector(selectCompanyId);
  const StaffCount = useSelector(selectBuyerStaffCount);
  const formattedBuyerAnalysisCount = formatNumberWithCommas(StaffCount);
  const globalSearchData = useSelector(selectBuyerPeopleData);
  const buyerStaffLoading = useSelector(selectBuyerStaffLoading);
  const searchPage = useSelector(selectSearchResultsPage);
  const searchLoading = useSelector(selectBuyerLoading);
  const extendedSearchLoading = useSelector(selectBuyerExtendedLoading);
  const selectedBuyerPerson = useSelector(selectBuyerStaffPerson);
  const buyerStaffPage = useSelector(selectBuyerStaffPage);
  const buyerStaff = useSelector(selectBuyerStaff);
  // const userId = useSelector(selectUserId);
  const personId = useSelector(selectPersonId);
  const [searchTerm, setSearchTerm] = useState('');
  const { count, linkedInCount } = globalSearchData;
  const totalCount = linkedInCount ? count + linkedInCount : count;
  const sendSearchCall = (keyword: string, pageCount = 1) => {
    const obj: SearchResultsRequest = {
      query: keyword.trim(),
      screenName: 'company',
      page: pageCount,
      from: 'buyerSearch',
      sortCompanyId: companyIdParsed,
      defaultLanguage: getLangCookie(),
      inSap: true,
    };
    dispatch(actionsSearch.affinitySearchResultsLoading(obj));
  };
  const onSearching = (keyword: string) => {
    // debugger;
    if (keyword.length) {
      dispatch(companyActions.setBuyerPeopleToShow({ data: [], page: 1 }));
      dispatch(companyActions.resetBuyerPage(1));
      const searchQuery = validateSearchQuery(keyword.trim());
      if (searchQuery.length === 0 || searchQuery === searchTerm) {
        return;
      }
      setSearchTerm(searchQuery);
      dispatch(actionsSearch.buyerAffinitySearchResultReset());
      sendSearchCall(searchQuery, 1);
      // dispatch(flurryActions.callFlurryEvent(
      //   valueToObject(`accountPlan_clickPersonSearch_${searchQuery}`, startTime, {}),
      // ));
    } else {
      setSearchTerm('');
      sendSearchCall('');
      // dispatch(companyActions.setBuyerPeopleToShow(buyerStaff));
      dispatch(actionsSearch.buyerAffinitySearchResultReset());
    }
  };

  const getMorePeople = () => {
    if (!searchLoading && ((buyerStaff?.length || 0) < totalCount)) {
      const obj: SearchResultsRequest = {
        query: searchTerm.trim(),
        screenName: 'company',
        page: searchPage + 1,
        from: 'buyerSearch',
        defaultLanguage: getLangCookie(),
      };
      dispatch(actionsSearch.affinitySearchResultsLoading(obj));
    }
  };

  const closePopup = () => {
    setShowPopupForSAP();
  };

  const onSubModel = () => {
    if (sapBuyerAnalysis) {
      updateDesignationsInSap();
      goToNextSlide();
    }
  };

  const itemClickHandler = (person: Executive) => {
    if (person.personType === 'LIVESEARCH') {
      dispatch(companyActions.getPersonProfile({
        personId: person.personId,
        type: person.personType,
        screenName: 'company',
        isBuyer: true,
      }));
      dispatch(UiAction.isShowUnderstandBlip(1));
    } else {
      const data = {
        livesearchId: 0,
        executiveId: person.personId,
        color: '',
      };
      dispatch(companyActions.setBuyerPersonId(data));
    }
    dispatch(companyActions.setSelectedBuyerPerson(person));
  };

  useEffect(() => {
    if (globalSearchData?.persons?.length !== 0) {
      dispatch(companyActions
        .setBuyerPeopleToShow({ data: globalSearchData?.persons || [], page: searchPage }));
      dispatch(companyActions.resetBuyerCount(totalCount));
    }
  }, [globalSearchData]);
  useEffect(() => {
    if (buyerStaff.length !== 0 && !Object.keys(selectedBuyerPerson).length) {
      const findPerson = buyerStaff.find((item: Executive) => item.personId === personId);
      const data = {
        livesearchId: 0,
        executiveId: findPerson?.personId || 0,
        color: '',
      };
      if (findPerson) {
        dispatch(companyActions.setSelectedBuyerPerson(findPerson));
        dispatch(companyActions.setBuyerPersonId(data));
      }
    }
  }, [buyerStaff]);

  useEffect(() => {
    if (searchTerm === '') {
      dispatch(companyActions.getBuyerStaff({
        page: buyerStaffPage,
        companyId: userCompanyIdParsed || 7126,
        screenName: 'noteable_sap',
      }));
    } else {
      dispatch(companyActions.setBuyerPeopleToShow({ data: buyerStaff || [], page: searchPage }));
    }
  }, [searchTerm]);

  const fetchMore = () => {
    if (searchTerm.length === 0) {
      dispatch(companyActions.getBuyerStaff({
        page: buyerStaffPage,
        companyId: userCompanyIdParsed || 7126,
        screenName: 'noteable_sap',
      }));
    } else {
      getMorePeople();
    }
  };
  const removeSelectedPerson = () => buyerStaff
    .filter((p) => p?.personId !== selectedBuyerPerson?.personId);

  return (
    <Wrapper>
      <Modal
        centered
        open={showPopupForSAP}
        onCancel={() => { closePopup(); }}
        width={379}
        wrapClassName={classNames('share-group-with-people-popup', { sapBuyerAnalysisStyles: sapBuyerAnalysis })}
        closable
        destroyOnClose
        getContainer={sapBuyerAnalysis ? (() => document.querySelector('.drawer-account-plan .ant-drawer-body') || document.body) : document.body}
      >
        <span className="heading-popup">
          Choose the person for Buyer Analysis
        </span>
        <div className="person-search-bar">
          <BuyerAlertSearch
            placeholderText="Search People"
            query={searchTerm}
            onSearching={onSearching}
            margin="0px"
            height="36px"
            searchQuery={buyerSearchQuery}
            setSearchQuery={setBuyerSearchQuery}
            prevSearchTerm={prevSearchTerm}
            setPrevSearchTerm={setPrevSearchTerm}
          />
        </div>
        <div className="d-flex justify-content-between">
          <span
            className="heading-popup second-heading-popup"
          >
            {`People (${buyerStaff?.length ? formattedBuyerAnalysisCount : 0})`}
          </span>
        </div>
        <div className="h-100 w-100" id="share-group-dropdown">
          <InfiniteScroll
            hasMore
            dataLength={buyerStaff?.length ?? 0}
            next={fetchMore}
            loader={false}
            className="share-group-dropdown"
            height="auto"
          // scrollableTarget="share-group-dropdown"
          >
            {
              selectedBuyerPerson?.personId && (
                <div className="search-item">
                  <div className="affinity-search-item">
                    <AffinitySearchResultItem
                      key={selectedBuyerPerson?.personId}
                      person={selectedBuyerPerson}
                      onClickHandler={() => itemClickHandler(selectedBuyerPerson)}
                      isSelected={false}
                      isDisabled={false}
                      checkboxShow
                      radioBtn={sapBuyerAnalysis}
                    />
                  </div>
                </div>
              )
            }
            {buyerStaff?.length ? removeSelectedPerson().map((person) => (
              <div className="search-item">
                <div className="affinity-search-item">
                  <AffinitySearchResultItem
                    key={person.personId}
                    person={person}
                    onClickHandler={() => itemClickHandler(person)}
                    isSelected={false}
                    isDisabled={false}
                    checkboxShow
                    radioBtn={sapBuyerAnalysis}
                  />
                </div>
              </div>
            )) : null}
            {
              buyerStaffLoading && (
                <div className="skeletons-for-search-item">
                  {[1, 2, 3, 4].map(() => <AffinitySearchResultItemSkeleton />)}
                </div>
              )
            }
            {(searchLoading || extendedSearchLoading) && (
              <div className="skeletons-for-search-item">
                {[1, 2].map(() => <AffinitySearchResultItemSkeleton />)}
              </div>
            )}
            {(!buyerStaff?.length
              && !buyerStaffLoading && !searchLoading && !extendedSearchLoading)
              ? <div className="no_data_found"><NoDataFound title={NODATAFOUND} /></div>
              : null}
          </InfiniteScroll>
        </div>
        <div className="share-group-footer">
          <span
            tabIndex={0}
            role="button"
            className={classNames(
              'share-group-button share-button',
              { disabled: !(Object.keys(selectedBuyerPerson)?.length) },
            )}
            onClick={() => onSubModel()}
            onKeyPress={() => onSubModel()}
          >
            {sapBuyerAnalysis ? 'Confirm' : 'Share'}
          </span>
          <span
            tabIndex={0}
            role="button"
            className="share-group-button cancel-button"
            onClick={() => closePopup()}
            onKeyPress={() => closePopup()}
          >
            Cancel
          </span>
        </div>
      </Modal>
    </Wrapper>
  );
};

BuyerGroupModal.defaultProps = defaultProps;
export default BuyerGroupModal;
